(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-faq-seo-copy"] && !Shopify.designMode) return;
  try {
    
  //FAQs Accordion
var acc = document.getElementsByClassName("faqs-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    var sticky = document.getElementById('checkout--sticky');
    if (!sticky) return;

    function getTargets() {
      var nodes = document.querySelectorAll('button[name="checkout"], input[type="submit"][name="checkout"]');
      return Array.prototype.filter.call(nodes, function (el) {
        return !el.closest('#checkout--sticky');
      });
    }

    function setStickyVisible(visible) {
      sticky.style.display = visible ? 'block' : 'none';
    }

    function computeShouldShow() {
      var targets = getTargets();
      if (!targets.length) return true;
      var t = targets[0];
      var r = t.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      
      var targetTop = r.top;
      var targetBottom = r.bottom;
      
      var isButtonInView = targetBottom > 0 && targetTop < vh;
      
      return !isButtonInView;
    }

    function update() {
      setStickyVisible(computeShouldShow());
    }

    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    update();

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    var mo = new MutationObserver(function () { update(); });
    mo.observe(document.body, { childList: true, subtree: true });
  });


  class DiscountInput extends HTMLElement {
    constructor() {
      super();
      this.applyButton = this.querySelector("#apply-discount-button");
      this.clearButtons = document.querySelectorAll(".clear-discount-button");
      this.discountCodeInput = this.querySelector("#discount-code-input");
      this.discountCodeError = this.querySelector("#discount-code-error");
    }

    connectedCallback() {
      this.applyButton?.addEventListener("click", this.handleApplyDiscount.bind(this));
      this.clearButtons.forEach(button => {
        button.addEventListener("click", this.handleClearDiscount.bind(this));
      });
    }

    async handleApplyDiscount(event) {
      event.preventDefault();
      if (this.discountCodeInput?.value) {
        const discountCode = this.discountCodeInput.value;

        try {
          // Apply the discount code
          await this.applyDiscount(discountCode);
        } catch (error) {
          console.error("Error applying discount:", error);
        }
      }
    }

    async handleClearDiscount(event) {
      event.preventDefault();

      try {
        // Clear the discount
        await this.clearDiscount();
      } catch (error) {
        console.error("Error clearing discount:", error);
      }
    }

    async clearDiscount(wrapper) {
      try {
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: '' })
        });

        await this.refreshCartSections();

        if (wrapper) {
          const discountValue = wrapper.querySelector('.applied-discount-code-value');
          if (discountValue) discountValue.innerHTML = '';
          const errorMessage = wrapper.querySelector('.discount-code-error');
          if (errorMessage) errorMessage.innerHTML = '';
          wrapper.style.display = 'none';
        }
      } catch (error) {
        console.error('Error clearing discount:', error);
      }
    }

    async applyDiscount(code) {
      if (this.applyButton) {
        this.applyButton.textContent = 'APPLYING';
        this.applyButton.disabled = true;
      }

      try {
        const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: code.trim() }) // multiple? 'CODE1,CODE2'
        });

        if (!res.ok) throw new Error(`Update failed: ${res.status}`);

        const cartData = await res.json();
        
        // Check if the discount was actually applied
        const appliedDiscounts = cartData.discount_codes || [];
        const isDiscountApplied = appliedDiscounts.some(discount => 
          discount.code.toLowerCase() === code.trim().toLowerCase() && discount.applicable === true
        );

        if (isDiscountApplied) {
          // Success - clear error and refresh
          if (this.discountCodeError) this.discountCodeError.innerHTML = '';
          await this.refreshCartSections();
        } else {
          // Discount not applied - show error
          this.displayError('Please enter a valid coupon code.<br>Gift cards & loyalty points are redeemed at checkout.');
        }
      } catch (error) {
        console.error('Error applying discount:', error);
        this.displayError('Please enter a valid coupon code.<br>Gift cards & loyalty points are redeemed at checkout.');
      } finally {
        if (this.applyButton) {
          this.applyButton.textContent = 'APPLY';
          this.applyButton.disabled = false;
        }
      }
    }

    displayError(message) {
      if (this.discountCodeError) {
        this.discountCodeError.innerHTML = message;
      }
    }

    async refreshCartSections() {         
      window.location.reload();
    }
  }

  customElements.define("discount-input", DiscountInput);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sas-product-details"] && !Shopify.designMode) return;
  try {
    
  //FAQs Accordion
var acc = document.getElementsByClassName("faqs-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

  
  } catch(e) { console.error(e); }
})();
})();
